import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const OrganisationDetail = ({ schema }: Props) => {
  const fields = [
    {
      field: 'registered_name',
      colSize: 18,
    },
    {
      field: 'country',
      colSize: 6,
    },
    {
      field: 'trade_as_name',
      colSize: 18,
    },
    {
      field: 'registered_number',
      colSize: 6,
    },
  ];

  return (
    <S9PageSection title="Organisation details" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default OrganisationDetail;
